import { render } from "./AgendaView.vue?vue&type=template&id=00926060"
import script from "./AgendaView.vue?vue&type=script&lang=js"
export * from "./AgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__